import { jsx, jsxs } from "react/jsx-runtime";
import success from "@ingka/ssr-icon/paths/checkmark-green-small";
import warning from "@ingka/ssr-icon/paths/warning-triangle-orange-small";
import error from "@ingka/ssr-icon/paths/notice-red-small";
import SSRIcon from "@ingka/ssr-icon";
import cx from "classnames";
import Text from "@ingka/text";
const getValidity = (valid) => {
  if (valid === true) {
    return "success";
  }
  if (valid === false) {
    return "error";
  }
  if (valid === "warning" || valid === "success" || valid === "error") {
    return valid;
  }
  return "";
};
const HelperText = (props) => {
  const {
    prefix = "",
    children,
    className,
    shouldValidate = false,
    valid = false,
    textOnly = false,
    ...otherProps
  } = props;
  const baseClass = `${prefix}helper-text`;
  const validity = getValidity(valid);
  const iconMap = { success, warning, error };
  const cssStyles = cx(
    baseClass,
    shouldValidate && validity !== "" && `${baseClass}--${validity}`,
    textOnly && `${baseClass}--text-only`,
    className
  );
  return /* @__PURE__ */ jsxs(
    Text,
    {
      tagName: "span",
      prefix,
      textStyle: "LabelRegular.S",
      colour: false,
      ...otherProps,
      className: cssStyles,
      children: [
        shouldValidate && validity !== "" && /* @__PURE__ */ jsx(
          SSRIcon,
          {
            viewBox: "0 0 18 18",
            prefix,
            className: `${baseClass}__icon`,
            paths: iconMap[validity]
          }
        ),
        children
      ]
    }
  );
};
HelperText.displayName = "HelperText";
var HelperText_default = HelperText;
export {
  HelperText,
  HelperText_default as default
};
